import { useNuxtApp } from '#app';
import { BaseService } from '../base/base.service';
import {
  ModelDepartment,
  ModelGETConversationAssociationConversation,
  ModelGETConversationAssociationConversationArchived,
  ModelGETConversationFeedback,
  ModelGETConversationFeedbackData,
  ModelOption,
  type IModelGETConversationAssociationConversationArchivedRequest,
  type IModelPUTConversationRequest,
} from './dto/conversation.dto';

import { ConversationRepository } from './conversation.repository';
import {
  ModelConversationDetail,
  ModelPOSTConversationAssociationConversationFile,
} from './dto/conversation.detail.dto';

export class ConversationService extends BaseService {
  private conversationRepository = new ConversationRepository(
    this.api,
    this.configService
  );

  async getConversationAssociationConversation(
    params: any
  ): Promise<ModelGETConversationAssociationConversation> {
    let dataResult = new ModelGETConversationAssociationConversation();
    try {
      const { $functions } = useNuxtApp();
      const res =
        await this.conversationRepository.getConversationAssociationConversation(
          params
        );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelGETConversationAssociationConversation(resData);
        console.log(
          'getConversationAssociationConversation',
          resData,
          dataResult
        );
      }
    } catch (err) {
      console.log(err, ConversationService.name);
    }
    return dataResult;
  }

  async getConversationAssociationConversationArchived(
    params: IModelGETConversationAssociationConversationArchivedRequest
  ): Promise<ModelGETConversationAssociationConversationArchived> {
    const { $functions } = useNuxtApp();
    let dataResult = new ModelGETConversationAssociationConversationArchived();
    try {
      const res =
        await this.conversationRepository.getConversationAssociationConversationArchived(
          params
        );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelGETConversationAssociationConversationArchived(
          resData
        );
        console.log(
          'getConversationAssociationConversationArchived',
          params,
          resData,
          dataResult
        );
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, ConversationService.name);
    }
    return dataResult;
  }

  async putConversation(params: IModelPUTConversationRequest): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult;

    try {
      const res = await this.conversationRepository.putConversation(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = resData.data;
        console.log('PUT Conversation', params, resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, ConversationService.name);
    }

    return dataResult;
  }

  async getConversationDetail(
    id: string | number
  ): Promise<ModelConversationDetail> {
    let dataResult: ModelConversationDetail = new ModelConversationDetail();
    try {
      const { $functions } = useNuxtApp();
      const res = await this.conversationRepository.getConversationDetail(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelConversationDetail(resData.data);
        console.log('getConversationDetail', resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, ConversationService.name);
    }
    return dataResult;
  }

  async createConversation(params: any): Promise<ModelConversationDetail> {
    let dataResult: ModelConversationDetail = new ModelConversationDetail();
    const { $functions } = useNuxtApp();
    try {
      const res = await this.conversationRepository.createConversation(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelConversationDetail(resData.data);
        console.log('createConversation', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, ConversationService.name);
    }
    return dataResult;
  }

  async initialConversation(params: any): Promise<ModelConversationDetail> {
    let dataResult: ModelConversationDetail = new ModelConversationDetail();
    const { $functions } = useNuxtApp();
    try {
      const res = await this.conversationRepository.initialConversation(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelConversationDetail(resData.data);
        console.log('initialConversation', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, ConversationService.name);
    }
    return dataResult;
  }

  async appendConversation(params: any): Promise<ModelConversationDetail> {
    let dataResult: ModelConversationDetail = new ModelConversationDetail();
    const { $functions } = useNuxtApp();
    try {
      const res = await this.conversationRepository.appendConversation(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelConversationDetail(resData.data);
        console.log('appendConversation', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, ConversationService.name);
    }
    return dataResult;
  }

  async *conversationPreview(params: any, abortController?: AbortController): AsyncGenerator<any, void, unknown> {
    const { $functions } = useNuxtApp();
    let reader: ReadableStreamDefaultReader<Uint8Array> | null = null;
    let isAborted = false;

    try {
      const response = await this.conversationRepository.conversationPreview(
        params, abortController?.signal
      );
      console.log('conversationPreview response', response);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      reader = response.body?.getReader() || null;
      if (!reader) {
        throw new Error('Response body is not readable');
      }

            // Listen for abort signal
      if (abortController?.signal) {
        abortController.signal.addEventListener('abort', () => {
          console.log('[SSE] Abort signal received - canceling reader');
          isAborted = true;
          if (reader) {
            reader.cancel('Stream aborted by user')
              .then(() => console.log('[SSE] Reader canceled successfully'))
              .catch((err) => console.error('[SSE] Reader cancel error:', err));
          }
        });
      }

      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        // Check if aborted before reading
        if (isAborted || abortController?.signal.aborted) {
          console.log('[SSE] Stream aborted, breaking loop');
          break;
        }
        const { done, value } = await reader.read();

        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('event:')) {
            continue;
          }

          if (line.startsWith('data:')) {
            const data = line.substring(5).trim();

            if (data === '[DONE]') {
              return;
            }

            try {
              const parsed = JSON.parse(data);
              yield parsed;
            } catch (e) {
              console.warn('Failed to parse SSE data:', data);
            }
          }
        }
      }
    } catch (err: any) {
      console.log('[SSE appendConversation] Stream error:', err);
      // Don't show error notification if it was aborted by user
      if (err.name === 'AbortError') {
        console.log('[SSE appendConversation] Stream aborted by user (AbortError caught)');
      } else {
        $functions.notify.error({
          text: err.message
        });
        console.error(err, ConversationService.name);
      }
    } finally {
      if (reader) {
        try {
          await reader.cancel();
          console.log('[SSE conversationPreview] Reader cleanup done');
        } catch (e) {
          console.log('[SSE conversationPreview] Reader cleanup error (ignored):', e);
        }
      }
    }
  }

  async conversationAssociationConversationFile(
    params: any
  ): Promise<ModelPOSTConversationAssociationConversationFile[]> {
    let dataResult: ModelPOSTConversationAssociationConversationFile[] = [];
    const { $functions } = useNuxtApp();
    try {
      const res =
        await this.conversationRepository.conversationAssociationConversationFile(
          params
        );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map(
          (e) => new ModelPOSTConversationAssociationConversationFile(e)
        );
        console.log(
          'conversationAssociationConversationFile',
          resData.data,
          dataResult
        );
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, ConversationService.name);
    }
    return dataResult;
  }

  async getModel(): Promise<ModelOption[]> {
    let dataResult: ModelOption[] = [];
    try {
      const { $functions } = useNuxtApp();
      const res = await this.conversationRepository.getModel();
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map((e) => new ModelOption(e));
        console.log('getModel', resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, ConversationService.name);
    }
    return dataResult;
  }

  async getDepartment(): Promise<ModelDepartment[]> {
    let dataResult: ModelDepartment[] = [];
    try {
      const { $functions } = useNuxtApp();
      const res = await this.conversationRepository.getDepartment();
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map((e) => new ModelDepartment(e));
        console.log('getDepartment', resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, ConversationService.name);
    }
    return dataResult;
  }

  async getConversationAssociationConversationFeedback(
    params: any
  ): Promise<ModelGETConversationFeedback> {
    let dataResult = new ModelGETConversationFeedback();
    try {
      const { $functions } = useNuxtApp();
      const res =
        await this.conversationRepository.getConversationAssociationConversationFeedback(
          params
        );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelGETConversationFeedback(resData);
        console.log(
          'getConversationAssociationConversationFeedback',
          resData,
          dataResult
        );
      }
    } catch (err) {
      console.log(err, ConversationService.name);
    }
    return dataResult;
  }
}
